import React, { Component } from "react";
import axios from "axios";

import Auxilary from "../Auxilary/Auxilary";
import PageTitle from "../Auxilary/PageTitle";
import { Footer } from "../Footer";

import "./ForgeTopic.css";
import "../Shared.css";

export class ForgeTopic extends Component {

    state = {
        isLoading: true,
        isError: false,
        doc: null
    }

    componentDidMount() {
        PageTitle.setTitle();
        axios.get('/ForgeDoc/' + this.props.match.params.id)
            .then((response) => {
                if (response.status === 200) {
                    this.setState({ isLoading: false, doc: response.data });
                } else {
                    this.setState({ isLoading: false, isError: true });
                }
            },
                (error) => {
                    this.setState({ isLoading: false, isError: true });
                    console.log(error);
                })
    }

    static renderDocContent(doc) {
        PageTitle.setTitle(doc.header + " | " + document.title);

        return (
            <Auxilary>
                <section>
                    <header>
                        <h1 className="forgeDocHeader">{doc.header}</h1>
                    </header>
                </section>
                <section>
                    <main dangerouslySetInnerHTML={{ __html: doc.content }}></main>
                </section>
                <section>
                    <Footer />
                </section>
            </Auxilary>
        );
    }

    render() {
        var content = "Loading topic ...";
        if (this.state.isError) {
            content = "Ooops... something went wrong. Please visit back a little bit later.";
        } else if (!this.state.isLoading) {
            content = ForgeTopic.renderDocContent(this.state.doc);
        }

        return (
            <Auxilary>
                {content}
            </Auxilary>
        );
    }

}
